export const lists_poi = [
    {
        "ID": 0,
        "name": "Park"
    },
    {
        "ID": 1,
        "name": "Meer"
    },
    {
        "ID": 2,
        "name": "Ziekenhuis"
    },
    {
        "ID": 3,
        "name": "Bos"
    },
    {
        "ID": 4,
        "name": "Bushalte"
    },
    {
        "ID": 5,
        "name": "Tramhalte"
    },
    {
        "ID": 6,
        "name": "Station"
    },
    {
        "ID": 7,
        "name": "Centraal Station"
    },
    {
        "ID": 8,
        "name": "Rangeeremplacement"
    },
    {
        "ID": 9,
        "name": "Buurtsuper"
    },
    {
        "ID": 10,
        "name": "Supermarkt"
    },
    {
        "ID": 11,
        "name": "Tankstation"
    },
    {
        "ID": 12,
        "name": "School"
    },
    {
        "ID": 13,
        "name": "Museum"
    },
    {
        "ID": 14,
        "name": "Winkelcentrum"
    },
    {
        "ID": 15,
        "name": "Garagebedrijf"
    },
    {
        "ID": 16,
        "name": "Snelweg oprit / afrit"
    },
    {
        "ID": 17,
        "name": "Kerstmarkt"
    },
    {
        "ID": 18,
        "name": "Magazijn"
    },
    {
        "ID": 19,
        "name": "Café/Club"
    },
    {
        "ID": 20,
        "name": "Stadion"
    },
    {
        "ID": 21,
        "name": "Boerderij"
    },
    {
        "ID": 22,
        "name": "Kantoorgebouw"
    },
    {
        "ID": 23,
        "name": "Zwembad"
    },
    {
        "ID": 24,
        "name": "Spoorwegovergang"
    },
    {
        "ID": 25,
        "name": "Theater"
    },
    {
        "ID": 26,
        "name": "Marktplein"
    },
    {
        "ID": 27,
        "name": "Rivier"
    },
    {
        "ID": 28,
        "name": "Sloot"
    },
    {
        "ID": 29,
        "name": "Vliegveld (klein): Start-/Landingsbaan"
    },
    {
        "ID": 30,
        "name": "Vliegveld (klein): Hangaar"
    },
    {
        "ID": 31,
        "name": "Vliegveld (klein): Vliegtuig parkeerplaats"
    },
    {
        "ID": 32,
        "name": "Vliegveld (groot): Start-/Landingsbaan"
    },
    {
        "ID": 33,
        "name": "Vliegveld (groot): Terminal"
    },
    {
        "ID": 34,
        "name": "Vliegveld (groot): Platform / Gate"
    },
    {
        "ID": 35,
        "name": "Vliegveld (groot): Parkeergarage"
    },
    {
        "ID": 36,
        "name": "Parkeergarage"
    },
    {
        "ID": 37,
        "name": "Verzorgingshuis"
    },
    {
        "ID": 38,
        "name": "Manege"
    },
    {
        "ID": 39,
        "name": "Hotel"
    },
    {
        "ID": 40,
        "name": "Restaurant"
    },
    {
        "ID": 41,
        "name": "Bankkantoor"
    },
    {
        "ID": 42,
        "name": "Sporthal"
    },
    {
        "ID": 43,
        "name": "Camping"
    },
    {
        "ID": 44,
        "name": "Gevangenis"
    },
    {
        "ID": 45,
        "name": "Asielzoekerscentrum"
    },
    {
        "ID": 46,
        "name": "Afvalverwerker"
    },
    {
        "ID": 47,
        "name": "Kerkgebouw"
    },
    {
        "ID": 48,
        "name": "Bouwmarkt"
    },
    {
        "ID": 49,
        "name": "Transformatorhuisje"
    },
    {
        "ID": 50,
        "name": "Industrieterrein"
    },
    {
        "ID": 51,
        "name": "Bedrijventerrein"
    },
    {
        "ID": 52,
        "name": "Haventerrein"
    },
    {
        "ID": 53,
        "name": "Bouwterrein"
    },
    {
        "ID": 54,
        "name": "Silo"
    },
    {
        "ID": 55,
        "name": "Huisartsenpraktijk"
    },
    {
        "ID": 56,
        "name": "Sportveld"
    },
    {
        "ID": 57,
        "name": "Jachthaven"
    },
    {
        "ID": 58,
        "name": "Frietkraam"
    },
    {
        "ID": 59,
        "name": "Verzorgingsplaats (Snelweg)"
    },
    {
        "ID": 60,
        "name": "Zendmast"
    },
    {
        "ID": 61,
        "name": "Stadscentrum"
    },
    {
        "ID": 62,
        "name": "Strand"
    },
    {
        "ID": 63,
        "name": "Strandopgang"
    },
    {
        "ID": 64,
        "name": "Duinen"
    },
    {
        "ID": 65,
        "name": "Tunnel"
    },
    {
        "ID": 66,
        "name": "Vuurwerkopslag"
    },
    {
        "ID": 67,
        "name": "Gasverdeelstation"
    },
    {
        "ID": 68,
        "name": "Windmolenpark"
    },
    {
        "ID": 69,
        "name": "Pretpark"
    },
    {
        "ID": 70,
        "name": "Circuit"
    },
    {
        "ID": 71,
        "name": "Pontsteiger"
    },
    {
        "ID": 72,
        "name": "Nucleaire installatie"
    }
]
